<div class="content-left">
  <div id="menu">
    <input type="checkbox" [(ngModel)]="menuOpen" (click)="showMenu()" role="button" [attr.aria-label]="!menuOpen ? 'Open Menu' : 'Close Menu'"/>
    <div class="menu-bar menu-bar--top">
      <div class="menu-bar--inner"></div>
    </div>
    <div class="menu-bar menu-bar--middle">
      <div class="menu-bar--inner"></div>
    </div>
    <div class="menu-bar menu-bar--bottom">
      <div class="menu-bar--inner"></div>
    </div>
  </div>
  <div class="app-logo">
    <!-- ICON -->
    <app-lu-icon icon="monogram" class="logo-icon"></app-lu-icon>
    <span class="logo-text">Shepherds</span>
  </div>
  <nav id="main-nav" [ngClass]="{'showNav' : menuOpen}" [attr.aria-hidden]="!menuOpen">
    <ul>
      <li>
        <a tabindex="0" routerLink="">
          <app-lu-icon icon="home"></app-lu-icon>
          Home
        </a>
      </li>

      @if (isDeveloper) {
        <li>
          <a tabindex="0" routerLink="/styleguide">
            <app-lu-icon icon="layout"></app-lu-icon>
            Styleguide
          </a>
        </li>
      }

      <li>
        <a tabindex="0" routerLink="/profile">
          <app-lu-icon icon="person"></app-lu-icon>
          Profile
        </a>
      </li>

      @if (menuOpen) {
        <li class="dropdown">
          <details>
            <summary>{{user?.currentUser?.printName}}</summary>
            <ul>
              @for (option of menuOptions; track option) {
                <li>
                  @if (option.external === true) {
                    <a href="{{option.path}}">{{option.optionText}}</a>
                  }
                  @if (option.external === undefined) {
                    <a href="#" [routerLink]="option.path">{{option.optionText}}</a>
                  }
                </li>
              }
            </ul>
          </details>
        </li>
        <li class="mobile-theme-changer">
          Change Theme: 
          <sl-theme-selector></sl-theme-selector>
        </li>
      }

      
    </ul>

  </nav>
</div>
<div class="content-right">
  <sl-theme-selector></sl-theme-selector>
  <app-menu-dropdown [username]="currentUser?.printName" [menuOptions]="menuOptions"></app-menu-dropdown>
</div>
